<script>
    import { state, res, ui, prefs, live } from './stores.js';
    
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css'; // optional for styling

    //import { textfit } from 'svelte-textfit';
    //import { flip } from 'svelte/animate';
    //import { crossfade } from 'svelte/transition';
    //import { quintOut } from 'svelte/easing';
    import {crossfade, customFlip} from './crossfade.js'
    const [send, receive] = crossfade
    import { convert, toggleSelect, isSelected, waiting, deselect, select, debounce } from './ui.js';
    import { mustPlayManual, getActions, drawCard, inPlay, look, shiftLeft, shiftRight, isBeingLookedAt, inMarket, isInPlay, canControlLocation, completeMission, getShiftActions, getCardIndex, isLastCardOfDeck, inHand, canPlay, canActivate, cardResourceTypes, faceupDraw, cardMessage, allTokenTypes, matches, defpCard, hasMurf } from './card_actions.js';
    import { cardOwner, getHints, missionComplete, checkMission, ongoingEffects, otherPlayer } from './parse.js';
    import { doAction, getCard, updateState } from './game.js';
    import { getIconURL, getShipCode, getVisitorCode} from './card_images.js';
    import CardImage from './CardImage.svelte';
    import TokenEdit from './TokenEdit.svelte';
    import { slide } from 'svelte/transition'
    import { afterUpdate } from 'svelte';
    import { get } from 'idb-keyval';
    import MissionStatus from './MissionStatus.svelte';
    import MissionProgress from './MissionProgress.svelte';
    import { perfCount, perfMeasure } from './perf.js';
    import { fireCardAction as fireCard } from './card_fire.js';
    import { displayMemo } from './displaymemo.js';

    export let c = false;
    export let facedown = false;
    export let deck;
    export let index = 0;
    export let name = false;
    export let partOfLook = false;
    export let beamed = false;
    export let single = false;
    export let hide = false;
    export let tuckDeck = false;
    export let tuckName = '';
    export let shiftable = false;
    
    let actionElement;
    afterUpdate(() => perfCount('render.Card.afterUpdate'));

    //$: console.log('tuck', tuckDeck, tuckName)

    $: if(!c && deck){
        c = deck[index];
    }

    

    let area;
    let deckName;
    let cardElement;
    let cardActions = [];
    let tip;

    $: if(c && c.uniqueID){
        area = $state.cardLog[c.uniqueID].area;
        deckName = $state.cardLog[c.uniqueID].deck;
        //if(area == 'players') p = $state.players[$state.cardLog[c.uniqueID].player];
    }

    //$: if(c && c.suits && c.suits.includes('mission') && $state.cardLog[c.uniqueID].area == 'players') updateStatus($state);
    

    function showTokens(c){
            if(!c) return false;
            if(inMarket(deck) || deck == $state.commons.neutral_zone) return true;
            if(inPlay(c)) return true;
            return false;
        }

    $: if(isSelected($ui, c) && !hide && (partOfLook || !isBeingLookedAt($ui, c))){
        if(!partOfLook && !isBeingLookedAt($ui, c) && deck && deck.length > 1 && (name == 'dev' || name == 'discard' || (name == 'draw' && faceupDraw(cardOwner(c)) || deck == $state.commons.junk || deck == $state.commons.rewards)/*|| waiting() == 'cards' && !facedown && !single && deck && deck.some(c => $ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID))*/)){
            //Do looking
            look(c);
            if(waiting() == 'cards' && $ui.waiting[0] && $ui.waiting[0].cards && !$ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID)){
                deselect(c);
            }
        }else if(waiting() != 'cards' || tuckDeck && tuckDeck.length > 0 && tuckName){
            cardActions = perfMeasure('render.Card.getActions', () => getActions(c, (facedown || c?.facedown)).filter(a => a.name && !a.hide), {card: c && c.id});
            if(!tip && cardElement && !hide){
                tip = tippy(cardElement, {
                    content: actionElement,
                    trigger: 'manual',
                    interactive: true,
                    appendTo: document.body,
                    //maxWidth: '50vw'
                })
            }

            //console.log(cardActions)

            if(tip && !hide && (cardActions.length > 0 || (facedown || c?.facedown) && deck && deck.length > 0 || tuckDeck && tuckDeck.length > 0 && tuckName)) tip.show();
        }else if(waiting() == 'cards' && $ui.waiting[0] && $ui.waiting[0].cards && $ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID) && $ui.waiting[0].reorder){
            //cardActions = getShiftActions();
            cardActions = [];
            //if(index == $ui.waiting[0].cards.length - 1) cardActions = cardActions.slice(-1);
            if(!tip && cardElement && !hide){
                tip = tippy(cardElement, {
                    content: actionElement,
                    trigger: 'manual',
                    interactive: true,
                    appendTo: document.body,
                    //maxWidth: '50vw'
                })
            }

            //console.log(cardActions)

            if(tip && !hide) tip.show();
        }
    }else{
        if(tip){
            tip.hide();
            tip.destroy();
            tip = null;
        }
    }

    function shouldDim(state, ui, c){
        if(!c) return false;
        //if(inHand(c) && !canPlay(cardOwner(c), c)) return true;
        //if(deck && deck)
        //if(facedown) return false;  
        if(c.inactive) return true;
        //if(c.unselectable) return true;
        if(waiting() == 'cards'){
            //console.log(c, ui.waiting[0].cards)
            //if(ui.waiting[0].cards.includes(c)) return false;
            if(!ui.waiting[0].cards) return false;
            if(ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID)) return false;
            if(!single && deck && deck.some(c => ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID))) return false;
            if(tuckDeck && tuckDeck.length > 0 && tuckDeck.some(c => ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID))) return false;
            return true;
        } 
        return false;
    }

    function canShift(c, ui){
        if(!c) return false;
        //console.log('check')
        if(waiting() == 'cards' && ui.waiting[0] && ui.waiting[0].cards && ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID) && ui.waiting[0].reorder) return true;
        return shiftable;
    }

    function isLastOfView(c, ui){
        //console.log('check2')
        if(waiting() == 'cards' && ui.waiting[0] && ui.waiting[0].cards && ui.waiting[0].cards.some(cd => cd.uniqueID == c.uniqueID)){
            let i = getCardIndex(c);
            if(i == ui.waiting[0].cards.length - 1) return true;
        }
        return false;
    }

    function shouldGlow(_state, ui, c){
        if(!c) return false;
        if((facedown || c?.facedown)) return false;  
        /*if(ui.selection && ui.selection.orbiting && ui.selection.orbiting.some(o => o.card == c.uniqueID)){
            return true;
        }else */
        if(displayMemo(`canActivate|${c.uniqueID}`, () => canActivate(c)) && !c.activated && $state.players[$state.currentPlayer].captain == cardOwner(c).captain){
            return true;
        }
        return false;
    }

    function shouldShowCount(state, prefs, c){
        if(!c) return false;
        if(!deck) return false;
        if(single) return false;
        if(partOfLook) return false;
        if(deckName == 'market_zone' || deckName == 'neutral_zone') return false;
        if(prefs.alwaysShowCount) return true;
        if(deck.length <= 1) return false;
        return true;
    }

    function hover(e){
        //console.log('hovering', c)
        if(!c || !c.uniqueID) return;
        $live.previewDashboard = null;
        $live.hoveringCard = c;
        $live.hoveringFacedown = (facedown || c?.facedown);
        $live.shouldHideHover = false;
    }

    function unhover(e){
        if(!c || !c.uniqueID) return;
        if($live.hoveringCard == c){
            $live.shouldHideHover = {x: e.clientX, y: e.clientY};
        }
    }

    function fireCardAction(e, type){
        return fireCard(c, type, e.shiftKey);
    }

    function getBeamStyle(beamed, seat, hasCards){
        if(!c) return '';
        // deckName is the name of the card owning us!
        if(beamed){
            let ownerCard = getCard(deckName);
            if(!ownerCard) return '';
            let ownerLocation = $state.cardLog[deckName].area;

            if(ownerLocation == 'commons' && c.sourcePlayer != seat){
                return `position: absolute; width: 100%; top: 15%;`;
            }else{
                return `position: absolute; width: 100%; top: -15%;`;
            }
        }
        return ``;
    }

    function checkRotate(beamed, seat, hasCards){
        if(beamed && deckName){
            let ownerCard = getCard(deckName);
            if(!ownerCard) return '';
            let ownerLocation = $state.cardLog[deckName].area;

            if(ownerLocation == 'commons' && c.sourcePlayer != seat){
                return true;
            }
        }
        return false;
    }

    function getTopTwo(cards){
        let p1Cards = cards.filter(c => c.sourcePlayer == 0);
        let p2Cards = cards.filter(c => c.sourcePlayer == 1);
        return [...p1Cards.slice(0,1), ...p2Cards.slice(0, 1)];
    }

    function beamedBreakdown(c){
        let beamed = c.beamed || [];
        let orbiting = c.orbiting || []
        let caps = Array.from(new Set([...beamed.map(b => b.sourcePlayer), ...orbiting.map(b => b.sourcePlayer)]));
        let data = [];
        //console.log(caps)
        for(let i of caps){
            let beams = beamed.filter(c => c.sourcePlayer == i);
            let traits = {}
            for(let b of beams){
                for(let t of b.traits){
                    if(!traits[t]) traits[t] = 0;
                    traits[t]++;
                }
            }
            
            let ships;
            ships = orbiting.filter(o => o.sourcePlayer == i);
            if($state.players && $state.players[i] && $state.players[i].captain){
                let entry = {
                    captain: $state.players[i].captain,
                    beams: beams.length,
                    orbit: ships.length,
                    list: Object.keys(traits).map(t => `${traits[t]} [[${t}]]`).join(', ')
                }
                data = [...data, entry];
            }
            //console.log(i, $state);
        }
        let consolidatedData = [];
        for(let d of data){
            if(!consolidatedData.some(entry => entry.captain == d.captain)) consolidatedData.push(d);
        }
        return consolidatedData; //Array.from(new Set(data));
    }

    $: if(c && !hide && $ui.cardMessage && $ui.cardMessage[c.uniqueID]){
        let t = tippy(cardElement, {
            trigger: 'manual',
            arrow: false,
            content: $ui.cardMessage[c.uniqueID],
            hideOnClick: false,
            onShow(instance) {
                setTimeout(() => {
                    instance.hide();
                    if(c) delete $ui.cardMessage[c.uniqueID]
                }, 2000);
            },
            theme: 'warning'
        });
       if(t && t.show && typeof t.show == 'function') t.show();
    }
 

</script>
    <div bind:this={cardElement} class="outer" class:selected={isSelected($ui, c)}  
    style="min-width: {$res.cardWidth * $prefs.cardScale}vmin; width:{$res.cardWidth * $prefs.cardScale}vmin; height: {$res.cardHeight * $prefs.cardScale}vmin; --width: {$res.cardWidth * $prefs.cardScale}vmin; --height: {$res.cardHeight * $prefs.cardScale}vmin; {getBeamStyle(beamed, $ui.seat, c && c.beamed && c.beamed.length > 0)}" 
    class:dimmed={shouldDim($state, $ui, c)} class:glowing={shouldGlow($state, $ui, c)}
    >
        {#if isSelected($ui, c) && (!partOfLook || single)}
            <div style="position: absolute; top: 0; left:0; z-index: 100000; width: {$res.cardWidth * $prefs.cardScale}vmin; height: {$res.cardHeight * $prefs.cardScale}vmin; border: 5px dashed orange; pointer-events: none; box-sizing: border-box;" />
        {/if}
        {#each c && c.beamed && c.beamed.length > 0 ? [ ...getTopTwo(c.beamed) ] : [] as card}
            {#if c && c.beamed}
                <svelte:self {hide} beamed={c.suits.includes('mission') ? 'committed' : 'beamed'} c={card} bind:deck={c.beamed}/>
            {/if}
        {/each}

        {#if tuckDeck && tuckDeck.length > 0}
            {#each [ tuckDeck[0] ] as card (card.uniqueID)}
                <div style="position: absolute; top: 0; left: 0; height: 100%; width: 100%; z-index: -999;" in:receive|global="{{key: card.uniqueID}}"
                    out:send|global="{{key: card.uniqueID, duration: 200}}" 
                    animate:customFlip><!-- on:outroend={ e=> { context.animating = false; console.log(document.querySelector('div[style*="animation"]')); }}  on:introend={ e=> { context.animating = false; console.log(document.querySelector('div[style*="animation"]'))}} -->
                        <CardImage facedown={(facedown || c?.facedown)} c={card} />
                    </div> 
            {/each}
        {/if}
        
        {#each [ c ] as c (c ? c.uniqueID: NaN)}
            <div style="height: 100%; position: relative;"
                    in:receive|global="{{key: c ? c.uniqueID : NaN, duration: 200 }}"
                    out:send|global="{{key: c ? c.uniqueID : NaN, duration: 200 }}"
                    animate:customFlip
                    on:mouseenter={hover}
                    on:mousemove={hover}
                    on:mouseleave={unhover}
                >
                <CardImage selectable={!shouldDim($state, $ui, c)} rotated={checkRotate(beamed, $ui.seat, c && c.beamed && c.beamed.length > 0)} facedown={(facedown || c?.facedown)} {c} />
                {#if c && !(facedown || c?.facedown) && c.murf}
                
                    {#if hasMurf($state.players[$ui.seat]) || hasMurf(otherPlayer($state.players[$ui.seat]))}
                        <div class="away {hasMurf($state.players[$ui.seat]) ? '' : 'theirs'}" style="font-size: {$prefs.buttonScale * 2}vmin; bottom: 30%; filter: drop-shadow(2px 4px 6px purple)">
                            <div transition:slide|global class="away_img" style="background-image: url({getIconURL('murf')});" /> 
                        </div>
                    {/if}
                {/if}
                {#if c && !(facedown || c?.facedown) && c.defp}
                    {#if defpCard($state.players[$ui.seat]) || defpCard(otherPlayer($state.players[$ui.seat]))}
                        <div class="away {defpCard($state.players[$ui.seat]) ? '' : 'theirs'}" style="font-size: {$prefs.buttonScale * 2}vmin; bottom: 30%; filter: drop-shadow(2px 4px 6px purple)">
                            <!--<div transition:slide|global class="away_img" style="background-image: url({getIconURL('defp')});" />-->
                            <div transition:slide|global class="away_img" style="background-image: url({getIconURL('defp')});" />
                        </div>
                    {/if}
                {/if}
                {#if c && !(facedown || c?.facedown) && c.hasOwnProperty('away_teams')}
                    {#if c.away_teams && Object.keys(c.away_teams).filter(k => $state.players[$ui.seat].captain == k).length > 0}
                        <div class="away" style="font-size: {$prefs.buttonScale * 2}vmin;">
                            {#each Object.keys(c.away_teams).filter(k => $state.players[$ui.seat].captain == k) as k}
                                <div transition:slide|global class="away_img" style="background-image: url({getIconURL('away-teams')}); {$state.players.findIndex(p => p.captain == k) != 0 ? 'filter: hue-rotate(180deg);' : ''}" /> 
                                <div transition:slide|global class="away_text" style={$state.players.findIndex(p => p.captain == k) != 0 ? 'color: pink;' : ''}>{c.away_teams[k]}</div>
                            {/each}
                        </div>
                        
                    {/if}
                    {#if c.away_teams && Object.keys(c.away_teams).filter(k => $state.players[$ui.seat].captain != k).length > 0}
                        <div class="away theirs" style="font-size: {$prefs.buttonScale * 2}vmin;">
                            {#each Object.keys(c.away_teams).filter(k => $state.players[$ui.seat].captain != k) as k}
                                <div transition:slide|global class="away_img" style="background-image: url({getIconURL('away-teams')}); {$state.players.findIndex(p => p.captain == k) != 0 ? 'filter: hue-rotate(180deg);' : ''}" /> 
                                <div transition:slide|global class="away_text" style={$state.players.findIndex(p => p.captain == k) != 0 ? 'color: pink;' : ''}>{c.away_teams[k]}</div> 
                            {/each}
                        </div>
                    {/if}
                {/if}
                {#if c && !(facedown || c?.facedown) && c.hasOwnProperty('drones')}
                    {#if c.drones && Object.keys(c.drones).filter(k => $state.players[$ui.seat].captain == k).length > 0}
                        <div class="drone" style="font-size: {$prefs.buttonScale * 2}vmin;">
                            {#each Object.keys(c.drones).filter(k => $state.players[$ui.seat].captain == k) as k}
                                <div transition:slide|global class="drone_img" style="background-image: url({getIconURL('drone')}); {$state.players.findIndex(p => p.captain == k) != 0 ? 'filter: hue-rotate(180deg);' : ''}" /> 
                                <div transition:slide|global class="drone_text" style={$state.players.findIndex(p => p.captain == k) != 0 ? 'color: orange;' : ''}>{c.drones[k]}</div>
                            {/each}
                        </div>
                    {/if}
                    {#if c.drones && Object.keys(c.drones).filter(k => $state.players[$ui.seat].captain != k).length > 0}
                        <div class="drone theirs" style="font-size: {$prefs.buttonScale * 2}vmin;">
                            {#each Object.keys(c.drones).filter(k => $state.players[$ui.seat].captain != k) as k}
                                <div transition:slide|global class="drone_img" style="background-image: url({getIconURL('drone')}); {$state.players.findIndex(p => p.captain == k) != 0 ? 'filter: hue-rotate(180deg);' : ''}" /> 
                                <div transition:slide|global class="drone_text" style={$state.players.findIndex(p => p.captain == k) != 0 ? 'color: pink;' : ''}>{c.drones[k]}</div> 
                            {/each}
                        </div>
                    {/if}
                {/if}
                {#if c && (deck == $state.commons.neutral_zone || ['Borg Queen', 'Q'].includes($state.players[$ui.seat].captain) && deck == otherPlayer($state.players[$ui.seat]).decks.locations) && displayMemo(`control|${$ui.seat}|${c.uniqueID}`, () => canControlLocation($state.players[$ui.seat], c))}
                    <div class="can_claim">✅</div>
                {/if}
                {#if c && deck == $state.commons.neutral_zone && $state.players.some((p, i) => $state.players[$ui.seat] != p && displayMemo(`control|${i}|${c.uniqueID}`, () => canControlLocation(p, c)))}
                    <div class="can_claim" style="left: unset; right: 10%;">✅</div>
                {/if}
            </div>
        {/each}

        {#if mustPlayManual(c) && !(facedown || c?.facedown)}
            <div class="auto_marker">🤚</div>
        {/if}
        {#if c && c.visiting}
            <div class="visiting" style="{$state.players[0].captain == 'Q' ? '--ship_colour: lightblue;' : '--ship_colour: pink;'}">
                {#each c.visiting as v}
                    {@const colour = $state.players[0].captain == 'Q' ? 0 : 1}
                    <div style="display: flex;">
                        <div class="qvisiting qtext">✨{getVisitorCode(v)}</div>
                    </div>
                {/each}
            </div>
        {/if}
        {#if c && c.orbiting}
            <div class="ships" style="{$ui.seat != 0 ? '--ship_colour: pink;' : '--ship_colour: lightblue;'}">
                {#each c.orbiting.filter(o => o.sourcePlayer == $ui.seat) as o (getShipCode(o.card, o.ship))}
                    <div style="display: flex;">{#if getIconURL(o.ship)}
                        <img 
                            on:click={e => {select(getCard(o.card, o.ship), false)}} class="image_ship ship invert" src={getIconURL(o.ship)} />
                            <div class="ship_text colour_{o.sourcePlayer}">{getShipCode(o.card, o.ship)}</div>
                    {:else}
                        <div 
                        class="image_ship ship ship_text colour_{o.sourcePlayer}">🚀{getShipCode(o.card, o.ship)}</div>
                    {/if}
                    </div>
                {/each}
            </div>
            <div class="ships theirs" style="{$ui.seat == 0 ? '--ship_colour: pink;' : '--ship_colour: lightblue;'}">
                {#each c.orbiting.filter(o => o.sourcePlayer != $ui.seat) as o (getShipCode(o.card, o.ship))}
                    <div style="display: flex;">{#if getIconURL(o.ship)}
                        <img
                        on:click={e => {select(getCard(o.card), false)}} class="image_ship ship  invert" src={getIconURL(o.ship)} />
                        <div class="ship_text colour_{o.sourcePlayer}">{getShipCode(o.card, o.ship)}</div>
                    {:else}
                        <div 
                        class="image_ship ship ship_text colour_{o.sourcePlayer}" >🚀{getShipCode(o.card, o.ship)}</div>
                    {/if}
                    </div>
                {/each}
            </div>
        {/if}

        <div class="buttons">
            {#if $prefs.showCardScores && single && !(facedown || c?.facedown) && c && c.id && $ui.cardScores[c.id]}
                <div class="score">
                    {$ui.cardScores[c.id]}VP
                </div>
            {/if}
            {#if name}
                <div class="name" style="font-size: {2.5 * $prefs.cardScale}vmin;">
                    {name.toUpperCase()}
                </div>
            {/if}
            {#if shouldShowCount($state, $prefs, c)}
                <div class="count">
                    {deck.length}
                </div>
            {/if}
            <!--{#if c && c.suits.includes('mission') && $state.cardLog[c.uniqueID].area == 'players'}
                <div style="font-size: {$prefs.buttonScale * 2}vmin;">
                    {#if c.complete}
                        ✅
                    {:else if missionComplete(c, $state.players[$state.cardLog[c.uniqueID].player]) == 'ready'}
                        👉
                    {/if}
                </div>
            {/if}-->
            {#if name == 'draw' && !partOfLook}
                <button style="font-size: {$prefs.buttonScale * 1.5}vmin;" on:click={async (e) => {await doAction($state.players[$ui.viewing], 'draw', {num: 1}); e.stopPropagation();}}>Draw</button>
            {/if}
            {#if !c && tuckDeck && tuckName && tuckDeck.length > 0}
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;"  on:click={e => {look(tuckDeck[0])}}>View {tuckName}</button>
                {/if}
            {#if c && c.activated}
                <img src="activations.png" style="width: 3vmin; pointer-events: all;" on:click={e => { doAction($state.players[$state.cardLog[c.uniqueID].player], 'deactivate', {card: c.uniqueID}) }}/>
            {/if}
            {#if c && c.ships && displayMemo(`inPlay|${c.uniqueID}`, () => isInPlay(c)) && !ongoingEffects(c).includes('cannot_warp') && $state.cardLog[c.uniqueID].area != 'beamed'}
                {#each c.ships as s  (getShipCode(c.uniqueID, s))}
                <div style="display: flex;">{#if getIconURL(s)}
                        {#if !c.orbitingCard || !c.orbitingCard[s]}
                            <img class="image_ship ship  invert" style='--ship_colour: black;' src={getIconURL(s)} />
                        {/if}
                        <div class="ship_text">{getShipCode(c.uniqueID, s)}</div>
                    {:else}
                        <div class="image_ship ship_text">{#if !c.orbitingCard || !c.orbitingCard[s]}🚀{/if}{getShipCode(c.uniqueID, s)}</div>
                    {/if}
                </div>
                {/each}
            {/if}
            {#if c && c.whereAmI}
                <div style="display: flex;">
                    <div class="qtext qcard">{getVisitorCode(c.uniqueID)}</div>
                </div>
            {:else if c && displayMemo(`inPlay|${c.uniqueID}`, () => isInPlay(c)) && $state.cardLog[c.uniqueID] && $state.cardLog[c.uniqueID].area != 'beamed' && matches(c, 'qsuit', false)}
                <div style="display: flex;">
                    <div class="qtext qvisiting">✨{getVisitorCode(c.uniqueID)}</div>
                </div>
            {/if}
            {#if showTokens(c)}
                <div class="tokens">
                    {#each allTokenTypes() as r}<!-- was  cardResourceTypes() but want to allow for more general placement now -->
                        {#if c[r]}
                            <TokenEdit card={true} p={c} {r} size={3} hideIfEmpty={!$ui.selection || c != $ui.selection}/>  
                        {/if}
                    {/each}
                    <!--{#if ongoingEffects(c).includes('dilithium_holder')}
                        <TokenEdit card={true} p={c} r="dilithium" size={3} hideIfEmpty={false}/>  
                    {/if}-->
                </div>
            {/if}
            <!--{#if c && c.status && !c.complete}
                <div class="progress_meter">
                    {#each Array(c.status.count > 0 ? c.status.count : 0) as _}
                        <div class="progress_done" style="filter:hue-rotate(-{(100-c.status.percent)/100*90}deg);"/>
                    {/each}
                    {#each Array(c.status.left > 0 ? c.status.left : 0) as _}
                        <div class="progress_not_done" />
                    {/each}
                </div>
            {/if}-->
            {#if !(facedown || c?.facedown) && c && c.uniqueID && c.suits && c.suits.includes('mission') && $state.cardLog[c.uniqueID].area == 'players'}
                <MissionProgress mission={c} p={cardOwner(c)} onCard={true}/>
            {/if}
        </div>
    </div>

    <div style="display: none;">
        <div bind:this={actionElement} class="card_action_container">
            {#if showTokens(c)}
                <div class="tokens">
                    {#each allTokenTypes() as r} <!-- cardResourceTypes() so that you can add others -->
                        <TokenEdit card={true} p={c} {r} size={3} hideIfEmpty={false}/>  
                    {/each}
                </div>
            {/if}
            {#if c && (c.beamed && c.beamed.length > 0 || c.orbiting && c.orbiting.length > 0)}
                {#each beamedBreakdown(c) as b}
                    <div class="legend" style="text-align: left;">
                        <div>
                            {b.captain}:  {#if b.beams}{b.beams} beamed{/if}{#if b.list} -&gt; {@html convert(b.list, true)}{/if}
                            {#if b.orbit}{#if b.list}, {/if}{b.orbit} ship{#if b.orbit > 1}s{/if}{/if}
                        </div>
                    </div>
                {/each}
            {/if}
            <div class="card_actions">
                {#if !(facedown || c?.facedown) && c && c.suits && c.suits.includes('mission') && c.status} <!--checkMission(cardOwner(c), c)-->
                    <MissionStatus m={c} status={c.status}/>
                {/if}
                {#if canShift(c, $ui) && getCardIndex(c, $ui) != 0}
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { shiftLeft(c); $ui = $ui; }}>&larr;</button>
                {/if}
                {#each cardActions as ca}
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" disabled={ca.disabled || false} on:click={e => { fireCardAction(e, ca.type); }}>{ca.name}</button>
                {/each}
                {#if tuckDeck && tuckName && tuckDeck.length > 0}
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;"  on:click={e => {look(tuckDeck[0])}}>View {tuckName}</button>
                {/if}
                {#if c && deck && deck.length > 0 && !single}
                    {#if (facedown || c?.facedown)}
                        <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { look(c, [0]) }}>Look at top 1</button>
                        <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { look(c, [0, 1]); }}>Look at top 2</button>
                        <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { look(c); }}>Find</button>
                    {:else if beamed}
                        <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { look(c); }}>Look at {beamed} cards</button>
                    {:else if deck.length > 1}
                        <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { look(c, [1]) }}>Look at top card of deck</button>
                    {/if}
                {/if}
                {#if deck == $state.commons.neutral_zone && $state.commons.locations.length > 0 && !partOfLook}
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { look($state.commons.locations[0], [0]); }}>Look at top card</button>
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { look($state.commons.locations[0], [0, 1, 2]); }}>Look at top 3</button>
                {/if}
                {#if canShift(c, $ui) && !isLastOfView(c, $ui)}
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => { shiftRight(c); $ui = $ui; }}>&rarr;</button>
                {/if}
            </div>
        </div>
    </div>
<style>

    .card_action_container {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 50vw;
    }

    .card_actions { 
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
        padding-top: 2vmin;
        padding-bottom: 2vmin;
        z-index: 99;
        top: 0%;
        pointer-events: all;
    }
    
    .outer {
        position: relative;
        display: block;
        width: 15.75vmin; 
        height: 22vmin;
        touch-action: manipulation;
        user-select: none;
        margin: auto;
        box-sizing: border-box;
    }


.selected {
    /*border: 3px dashed orange;*/
    /*margin: 0.5px;*/
    filter: saturate(3)
}

.buttons {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
        padding-top: 2vmin;
        padding-bottom: 2vmin;
        z-index: 99;
        top: 0%;
        width: 100%;
        /*height: 100%;*/
        pointer-events: none;
    }

    button, select {
        pointer-events: all;
    }

    button {
        font-size: 1.5vmin;
    }

    .name {
        font-weight: bold;
        font-style: italic;
        color: lightblue;
        font-size: 2.5vmin;
        text-shadow: 0px 0px 10px black;
        background-color: rgba(0,0,0,0.3);
        padding: 5px;
        border-radius: 10px;
        text-align: center;
        max-width: 100%;
    }

    .away_img {
        display: flex;
        flex-wrap: nowrap;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        align-items: center;
    }

    .away_text {
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: aqua;
    }

    .murf_text {
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: purple;
    }

    .drone_img {
        display: flex;
        flex-wrap: nowrap;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        align-items: center;
    }

    .drone_text {
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: lime-green;
    }
    .can_claim {
        pointer-events: none;
        position: absolute;
        bottom: 35%;
        left: 10%;
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .away {
        pointer-events: none;
        position: absolute;
        bottom: 10%;
        left: 10%;
        width: 30%;
        height: 25%;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        font-weight: bold;
        font-size: 2.5vmin;
        /*text-shadow: 0px 0px 10px black;
        background-color: rgba(0,0,0,0.3);
        border-radius: 10px;*/
    
    
    }

    .drone {
        pointer-events: none;
        position: absolute;
        bottom: 10%;
        left: 10%;
        width: 30%;
        height: 25%;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        font-weight: bold;
        font-size: 2.5vmin;
        /*text-shadow: 0px 0px 10px black;
        background-color: rgba(0,0,0,0.3);
        border-radius: 10px;*/
    
    
    }

    .auto_marker {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.9;
    }

    

    .ships {
        pointer-events: none;
        position: absolute;
        top: 15%;
        left: 10%;
        width: 30%;
        height: 25%;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        align-items: center;
    }
    
    .visiting {
        pointer-events: none;
        position: absolute;
        top: 10%;
        left: 0;
        right: 0;
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 5%;
    }

    .tokens {
        display: flex;
    }


    .theirs {
        left: unset;
        right: 10%;
    }

     .count {
        font-weight: bold;
        font-size: 2.5vmin;
        text-shadow: 0px 0px 10px black;
        background-color: rgba(0,0,0,0.3);
        border-radius: 10px;
    }

    .score {
        font-weight: bold;
        font-size: 3vmin;
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: yellow;
    }

    .dimmed {
        /*opacity: 50%;*/
        /*filter: grayscale(1);*/
        opacity: 50%;
    }

    .glowing {
        box-shadow: 0 0 10px 5px pink;
    }

    .unauto {
        box-shadow: 0 0 10px 5px darkred;
    }

    .orbiting {
        box-shadow: 0 0 10px 5px pink;
    }

    .qvisiting {
        color: white;
        background-color: deeppink;
        padding: 5%;
        line-height: 1.3;
        text-align: center;
        border-radius: 30%;
        filter: drop-shadow(2px 2px 2px black);
    }

    .qtext {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 0.75em;
        white-space: nowrap;
    }

    .qcard {
        color: deeppink;
        background-color: white;
        padding: 5%;
        text-align: center;
        border-radius: 30%;
    }

    .legend {
        font-weight: bold;
        font-style: italic;
        z-index: 200;
        text-shadow: 10px 10px 10px black;
        background-color: rgba(0,0,0,0.3);
        padding: 5px;
        border-radius: 10px;
        height: fit-content;
        width: fit-content;
        pointer-events: none;
        color: lightgrey;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
    }

    .value_image {
        object-fit: contain;
        max-height: calc(var(--height) / 10);
        min-width: calc(var(--width) / 4);
    }
    .image_ship {
        object-fit: contain;
        max-height: calc(var(--height) / 8);
        min-width: calc(var(--width) / 2.5);
        pointer-events: all;
        cursor: pointer;
    }

    .ship_text {
        font-weight: bold;
        font-size: calc(var(--height) / 8);
        color: black;
        filter: drop-shadow(1px 1px white) drop-shadow(1px -1px white) drop-shadow(-1px 1px white) drop-shadow(-1px -1px white);
    }
    
    .colour_0 {
        color: blue;
    }

    .colour_1 {
        color: red;
    }

    .ship {
        /*filter: drop-shadow(5px 5px 10px blue);
        box-shadow: 0 0 10px 5px red;*/
        filter: opacity(0.8) drop-shadow(1px 1px var(--ship_colour)) drop-shadow(1px -1px var(--ship_colour)) drop-shadow(-1px 1px var(--ship_colour)) drop-shadow(-1px -1px var(--ship_colour))
    }

    .invert {
        filter: invert(1) drop-shadow(1px 1px var(--ship_colour)) drop-shadow(1px -1px var(--ship_colour)) drop-shadow(-1px 1px var(--ship_colour)) drop-shadow(-1px -1px var(--ship_colour));;
    }

    .progress_meter {
        width: 100%;
        height: 1vmin;
        display: flex;
        flex-wrap: nowrap;
        position: absolute;
        bottom: 0;
        opacity: 80%;
    }

    .progress_element {
        border: 0.1px solid black;
        width: 100%;
    }

    .progress_done {
        background-color: green;
        
    }

    .progress_element + .progress_element {
        border-left: none;
    }

    .progress_not_done {
        background-color: white;
    }
</style>
